import React, { useMemo } from 'react';
import { KnightKey, FaeKey, ContextMenuData } from '../../types';
import { SWORN_DATA } from '../../gameData';
import { IconType, IconPathOptions } from '../../utils/iconPath';
import KnightItem from './items/KnightItem';
import FaeItem from './items/FaeItem';

interface DefaultSelectionPanelProps {
  selectedKnight: KnightKey | null;
  onKnightSelect: (knight: KnightKey) => void;
  onFaeSelect: (fae: FaeKey) => void;
  getIconPath: (type: IconType, name: string, options?: IconPathOptions) => string;
  contextMenu?: ContextMenuData | null;
  closeContextMenu?: () => void;
  handleContextMenu?: (e: React.MouseEvent, target: string, type: ContextMenuData['type'], options?: string[]) => void;
}

const DefaultSelectionPanel: React.FC<DefaultSelectionPanelProps> = ({
  selectedKnight,
  onKnightSelect,
  onFaeSelect,
  getIconPath,
  contextMenu,
  closeContextMenu,
  handleContextMenu
}) => {
  const knightKeys = useMemo(() => {
    return (SWORN_DATA.ui_config?.knight_sort_order || Object.keys(SWORN_DATA.classes)) as KnightKey[];
  }, []);

  const faeKeys = useMemo(() => {
    return (SWORN_DATA.ui_config?.fae_sort_order || Object.keys(SWORN_DATA.fae_lords)) as FaeKey[];
  }, []);

  return (
    <>
      {/* Knights */}
      {knightKeys.map((knight, index) => (
        <KnightItem
          key={knight}
          knight={knight}
          index={index}
          contextMenu={contextMenu || null}
          closeContextMenu={closeContextMenu}
          onKnightSelect={onKnightSelect}
          handleContextMenu={handleContextMenu}
        />
      ))}

      {/* Fae Grid */}
      <div id="fae-grid-container">
        {faeKeys.map((fae) => (
          <FaeItem
            key={fae}
            fae={fae}
            contextMenu={contextMenu || null}
            closeContextMenu={closeContextMenu}
            onFaeSelect={onFaeSelect}
            handleContextMenu={handleContextMenu}
            getIconPath={getIconPath}
          />
        ))}
      </div>
    </>
  );
};

export default DefaultSelectionPanel;
